module.exports = __webpack_public_path__ + "2965fdc17a89b9c056d2bab66c2103be.MP3";